import React from 'react';
import {Route} from 'react-router-dom';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';
import AsyncPage from './async';

export default [
  <Route
    key="/business/integration-partner"
    element={
      <DefaultBusinessLayout
        isEnterprise={true}
        breadcrumb={[
          {
            position: 1,
            name: 'Business',
            item: '/business',
          },
          {
            position: 2,
            name: 'Integration Partners',
            item: '/business/integration-partner',
          },
        ]}
        showContactSales={false}
      />
    }
  >
    <Route path="business/integration-partner" element={<AsyncPage />} />
  </Route>,
];
